module.exports = __webpack_public_path__ + "static/media/face-happy.e541a9f6.svg";